'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { type ReactNode, useEffect, useRef, useState } from 'react';
import styles from './AnimatedPopoverContent.module.css';
type AnimatedPopoverContentProps = {
  viewKey: string | number;
  className?: string;
  children: ReactNode;
};
export function AnimatedPopoverContent(t0) {
  const $ = _c(13);
  const {
    viewKey,
    className,
    children
  } = t0;
  const [contentHeight, setContentHeight] = useState();
  const contentRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const el = contentRef.current;
      if (!el) {
        return;
      }
      const observer = new ResizeObserver(() => setContentHeight(el.offsetHeight));
      observer.observe(el);
      return () => observer.disconnect();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== contentHeight) {
    t3 = {
      height: contentHeight
    };
    $[2] = contentHeight;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== className) {
    t4 = clsx(styles.view, className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== children || $[7] !== t4 || $[8] !== viewKey) {
    t5 = <div ref={contentRef}><div key={viewKey} className={t4}>{children}</div></div>;
    $[6] = children;
    $[7] = t4;
    $[8] = viewKey;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <div className={styles.root} style={t3}>{t5}</div>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}